import { Routes, Route, Navigate } from 'react-router';
import MainLayout from './components/layout/MainLayout.jsx';
import Dashboard from './pages/Dashboard/index.jsx';
import Periods from './pages/Periods/index.jsx';
import Tasks from './pages/Tasks/index.jsx';
import Leaderboard from './pages/Leaderboard/index.jsx';
import Parameters from './pages/Parameters/index.jsx';
import Audit from './pages/Audit/index.jsx';
import Badges from './pages/Badges/index.jsx';

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="periods/*" element={<Periods />} />
        <Route path="tasks/*" element={<Tasks />} />
        <Route path="leaderboard" element={<Leaderboard />} />
        <Route path="parameters/*" element={<Parameters />} />
        <Route path="audit" element={<Audit />} />
        <Route path="badges" element={<Badges />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
